module.exports = __webpack_public_path__ + "img/8.391a00a5.jpg";